import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import { data, event } from "jquery";

const VerifyOtp = (props) => {
  const [passwordShown, setPasswordShown] = useState(false);
  const [otp, setOTP] = useState();
  const [error, setError] = useState(null);
  const [timer, setTimer] = useState(60); // Initial timer value in seconds
  const [isTimerRunning, setIsTimerRunning] = useState(true);
  const [attemptCount, setAttemptCount] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  // Timer START 

  useEffect(() => {
    let countdown; // Variable to hold the countdown interval

    // Function to decrement the timer every second
    const startTimer = () => {
      countdown = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 0) {
            clearInterval(countdown); // Stop the countdown when timer reaches 0
            setIsTimerRunning(false);
            return 60; // Reset timer to initial value
          }
          return prevTimer - 1; // Decrement timer by 1 second
        });
      }, 1000);
    };

    // Start the timer when isTimerRunning becomes true
    if (isTimerRunning) {
      startTimer();
    } else {
      clearInterval(countdown); // Clear interval if timer is not running
    }

    // Clean up function to clear the interval when component unmounts or when timer stops
    return () => clearInterval(countdown);
  }, [isTimerRunning]);



  // END


  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const verifyLoginOTP = async (data) => {
    setAttemptCount((prev) => {
      const newCount = prev + 1;
      if (newCount >= 6) {
        setIsButtonDisabled(true);
      }
      return newCount;
    });
    props.handleClose(data.otp);
  };

  const resendOtp = async () => {
    props.resendOtp(otp);
    setIsTimerRunning(true);
    setAttemptCount(0);
    setIsButtonDisabled(false);
  };
  return (
    <>
      <form
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(verifyLoginOTP)}
      >
        <p className="lead fw-bold me-3 text-secondary mb-1">
          <span className="text-dark h6">
            A otp has been sent to Registered  Mobile Number
          </span>
        </p>
        {/* OTP input */}
        <div className="form-outline mb-3 mt-4">
          <label className="form-label" htmlFor="otp">
            Enter OTP
          </label>
          <div className="">
            <input
              className="form-control form-control-lg"
              type="number"
              id="otp"
              name="otp"
              value={otp}
              maxLength={6}
              onInput={(e) => {
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.slice(0, 6);
                }
              }}
              onChange={(event) => setOTP(event.target.value)}
              {...register("otp", {
                required: "This is required."
              })}
            />
            {errors.otp && (
              <ErrorLabel message={errors.otp?.message} />
            )}
            <input type="hidden" name="code" value="axis"></input>
          </div>
          {error && <p>{error}</p>}
        </div>
        <div>
          <div className="text-center text-primary">
            {!isTimerRunning && (
              <a onClick={resendOtp}>Resend OTP</a>
            )}
            {isTimerRunning && <p>Resend OTP in {timer} seconds</p>}
          </div>
        </div>


        <div className="text-center text-lg-start mt-4">
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={isButtonDisabled}
          >
            Verify OTP
          </button>
        </div>
      </form>
    </>
  );
};

export default VerifyOtp;
